<template>
  <div>
    <div class="row">
      <div class="col-md-2 aCenter">
        <img
          src="@/assets/images/big-check.svg"
          class="arrow mb-30"
          width="90px"
          alt
        />
      </div>
      <div class="col-md-10">
        <div class="row">
          <div class="col-md-10 success-info">
            <h2>{{ this.title }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5 aCenter">
        <button
          type="submit"
          class="btn btn-core fw mt-10"
          @click="changeComponent('Details')"
          :disabled="authIsLoading || merchantIsLoading || customerIsLoading"
          v-if="webDesign !== null && webDesign.design !== null"
          :style="{ 
            backgroundColor: webDesign.design.main_color+'!important',
            border: 'none !important',
            color: webDesign.design.button_text_color+'!important'
          }"
        >
          BACK TO PROFILE
        </button>
        <button
          type="submit"
          class="btn btn-core fw mt-10"
          @click="changeComponent('Details')"
          :disabled="authIsLoading || merchantIsLoading || customerIsLoading"
          v-else
        >
          BACK TO PROFILE
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      form: {
        firstname: "",
        lastname: ""
      }
    };
  },
  props: {
    title: String
  },
  computed: {
    ...mapState("auth", {
      token: state => state.token,
      authErrors: state => state.errors,
      authIsLoading: state => state.loading
    }),
    ...mapState("customer", {
      customer: state => state.user,
      customerErrors: state => state.errors,
      customerIsLoading: state => state.loading
    }),
    ...mapState("merchant", {
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken,
      merchantIsLoading: state => state.loading,
      merchantErrors: state => state.errors
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign
    }),
  },
  methods: {
    changeComponent(component) {
      this.$emit("change-component", component);
      this.$emit("change-title", "Name Updated!");
    }
  }
};
</script>

<style lang="scss" scoped></style>
